import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Videos from "./pages/Videos";
import Film35mm from "./pages/Film35mm";
import Aesthetics from "./pages/Aesthetics";
import Contact from "./pages/Contact";
import { VideoManagerProvider } from "./context/VideoManager";


function App() {
  return (
    <VideoManagerProvider>

      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/adverts" element={<Videos />} />
          <Route path="/film" element={<Film35mm />} />
          <Route path="/aesthetics" element={<Aesthetics />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Router>
      </VideoManagerProvider>

  );
}

export default App;
